import AWS from 'aws-sdk';

AWS.config.update({
   accessKeyId: process.env.AWS_ACCESS_KEY || "AKIAY76T7ZNL6VJXF6KY",
    secretAccessKey: process.env.AWS_SECRET_KEY || "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",
    region: process.env.AWS_REGION || "us-west-1",
});

const s3 = new AWS.S3();

export default s3
